import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useEffect, useState } from 'react';

import ModalAllder from 'components/layout/ModalAllder';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import { FieldArray, Form, Formik } from 'formik';
import { createPortal } from 'react-dom';
import * as yup from 'yup';

export default function ModalSort({ modal, setModal, onFormSubmit, setCustomSort }) {
  const sortOptions = [
    { value: 0,                label: 'ไม่มี' },
    { value: 'documentNumber', label: 'เลขที่เอกสาร' },
    { value: 'documentDate',   label: 'วันที่เอกสาร' },
    { value: 'quantity',       label: 'จำนวนรายการ' },
    { value: 'taxable_amount', label: 'มูลค่าก่อนภาษี' },
    { value: 'vat',            label: 'มูลค่าภาษี' },
    { value: 'total_amount',   label: 'มูลค่าสุทธิ' },
  ];

  const defaultSort = [
    { no: 1, field: 0, direction: 'asc' },
    { no: 2, field: 0, direction: 'asc' },
    { no: 3, field: 0, direction: 'asc' },
  ];

  const [formdata, setFormdata] = useState({ sort: defaultSort });

  const schema = yup.object().shape({});

  // reset ทุกครั้งที่ modal เปิด
  useEffect(() => {
    if (modal.open) {
      setFormdata({ sort: defaultSort });
    }
  }, [modal.open]);

  // กรอง options ที่ถูกเลือกในแถวอื่นออก
  const getAvailableOptions = (currentIndex, values) => {
    const selectedFields = values.sort
      .map((sort, index) => (index !== currentIndex ? sort.field : null))
      .filter((field) => field !== null && field !== 0);

    return sortOptions.filter(
      (option) => option.value === 0 || !selectedFields.includes(option.value)
    );
  };

  // เมื่อเลือก field ใหม่ → clear แถวอื่นที่เลือก field เดียวกัน
  const handleFieldChange = (index, newValue, setFieldValue, values) => {
    setFieldValue(`sort[${index}].field`, newValue);

    values.sort.forEach((sort, sortIndex) => {
      if (sortIndex !== index && sort.field === newValue && newValue !== 0) {
        setFieldValue(`sort[${sortIndex}].field`, 0);
      }
    });
  };

  return (
    <>
      {createPortal(
        <ModalAllder modal={modal} setModal={setModal} htitle={'จัดเรียง'} hbtn={true}>
          <Formik
            initialValues={formdata}
            validationSchema={schema}
            enableReinitialize
            onSubmit={(values) => {
              onFormSubmit(values);
            }}
          >
            {({ handleSubmit, touched, errors, values, setFieldValue }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <div className="px-lg-4">
                  <div className="py-1"></div>

                  <Table
                    sx={{
                      maxWidth: 750,
                      color: '#4C4E64DE',
                      '& .MuiTableCell-root': {
                        border: '1px solid rgba(224, 224, 224, 1)',
                        padding: '10px',
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow style={{ background: '#e5e5e585' }}>
                        <TableCell align="center" width={'15%'} className="!py-4">
                          ลำดับ
                        </TableCell>
                        <TableCell align="center">รายการแสดงผล</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <FieldArray
                        name="sort"
                        render={() => (
                          <>
                            {values.sort.map((sort, index) => {
                              const availableOptions = getAvailableOptions(index, values);
                              return (
                                <TableRow key={`sort-${index}`} style={{ background: 'white' }}>
                                  <TableCell align="center">
                                    <div className="font-weight-bold">{sort.no}</div>
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      select
                                      label=""
                                      variant="outlined"
                                      fullWidth
                                      onChange={(e) =>
                                        handleFieldChange(index, e.target.value, setFieldValue, values)
                                      }
                                      name={`sort[${index}].field`}
                                      value={values.sort[index].field}
                                      error={
                                        errors.sort?.[index]?.field &&
                                        touched.sort?.[index]?.field
                                      }
                                    >
                                      {availableOptions.map((option) => (
                                        <MenuItem
                                          key={`${index}-${option.value}`}
                                          value={option.value}
                                        >
                                          {option.label}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </>
                        )}
                      />
                    </TableBody>
                  </Table>

                  <div className="flex items-center mt-10">
                    <Button
                      variant="contained"
                      color="blue3"
                      className="!mr-auto"
                      onClick={() => {
                        setCustomSort(true);
                        setModal((prev) => ({ ...prev, open: false }));
                      }}
                    >
                      จัดเรียงด้วยตนเอง
                    </Button>

                    <Button
                      variant="outlined"
                      color="gray"
                      className="!px-7"
                      onClick={() => setModal((prev) => ({ ...prev, open: false }))}
                    >
                      ยกเลิก
                    </Button>

                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className="!px-7 !ml-4"
                      disabled={!values.sort.some((s) => s.field !== 0)}
                    >
                      จัดเรียง
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ModalAllder>,
        document.body
      )}
    </>
  );
}
